module.exports = __webpack_public_path__ + "img/zt.81a95300.png";